
import React from "react";
import PuttingScoreButtons from "./PuttingScoreButtons";
import ChippingScoreButtons from "./ChippingScoreButtons";
import WedgingScoreButtons from "./WedgingScoreButtons";
import BunkerScoreButtons from "./BunkerScoreButtons";
import IronScoreButtons from "./IronScoreButtons";
import FairwayWoodScoreButtons from "./FairwayWoodScoreButtons";
import DriverScoreButtons from "./DriverScoreButtons";
import GreenAttack2ZoneScoreButtons from "./GreenAttack2ZoneScoreButtons";
import { BallTendency } from "@/hooks/level3/types";

interface ScoringButtonsSelectorProps {
  isPutting: boolean;
  isChipping: boolean;
  isWedging: boolean;
  isBunker: boolean;
  isIron: boolean;
  isFairwayWood: boolean;
  isDriver: boolean;
  testId?: string | null;
  onScoreChange: (score: number, tendency?: BallTendency) => void;
}

const ScoringButtonsSelector: React.FC<ScoringButtonsSelectorProps> = ({
  isPutting,
  isChipping,
  isWedging,
  isBunker,
  isIron,
  isFairwayWood,
  isDriver,
  testId,
  onScoreChange
}) => {
  // Check if this is the green attack 2-zone test
  const isGreenAttack2Zone = testId === "iron-green-attack-100";
  
  if (isPutting) {
    return <PuttingScoreButtons onScoreChange={onScoreChange} />;
  }
  
  if (isChipping) {
    return <ChippingScoreButtons onScoreChange={onScoreChange} />;
  }
  
  if (isWedging) {
    return <WedgingScoreButtons onScoreChange={onScoreChange} />;
  }
  
  if (isBunker) {
    return <BunkerScoreButtons onScoreChange={onScoreChange} />;
  }
  
  if (isGreenAttack2Zone) {
    return <GreenAttack2ZoneScoreButtons onScoreChange={onScoreChange} />;
  }
  
  if (isIron) {
    return <IronScoreButtons onScoreChange={onScoreChange} />;
  }
  
  if (isFairwayWood) {
    return <FairwayWoodScoreButtons onScoreChange={onScoreChange} />;
  }
  
  if (isDriver) {
    return <DriverScoreButtons onScoreChange={onScoreChange} />;
  }
  
  // Default: use putting buttons
  return <PuttingScoreButtons onScoreChange={onScoreChange} />;
};

export default ScoringButtonsSelector;
